<template>
  <div class="designer-menu">
    <scrollable-container>
      <div
        class="group"
        v-for="group in menuItems"
        :key="group.label"
      >
        <h6>{{ group.label }}</h6>
        <draggable
          class="list-group"
          v-model="group.items"
          :options="group.options"
          :clone="group.onClone"
        >
          <div
            v-for="item in group.items"
            :key="item.id"
            class="menu-item drag-handler"
          >
            {{ item.label }} <i class="icon-drag_handle"/>
          </div>
        </draggable>
      </div>
    </scrollable-container>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import Draggable from 'vuedraggable'
import ScrollableContainer from '@/components/scrollable-container'

export default {
  name: 'DesignerMenu',
  components: {
    ScrollableContainer,
    Draggable
  },
  props: {
    menuItems: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style lang="scss">
  .designer-menu {
    .group {
      padding: 20px 0;
      h6 {
        text-transform: uppercase;
        font-size: 10px;
        margin: 0;
        padding: 10px;
        @include font-primary(8px, normal);
        color: #999999;
        display: block;
        border-bottom: 1px solid #efefef;
      }
      .menu-item {
        padding: 15px;
        transition: all .3s ease-in;
        &:hover {
          background-color: #f0f0f0;
          cursor: grab;
          i.icon-drag_handle {
            color: #999999;
          }
        }
        i.icon-drag_handle {
          transition: all .3s ease-in-out;
          float: right;
          color: #dddddd;
          font-size: 24px;
          margin-top: -5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/designer/designer-menu.vue